<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="select_container">
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-form-item>
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.name" placeholder="用户昵称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="currentPage=1,getinstitution()">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>

    <div class="table_container">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="index" label="序号" width="100"></el-table-column>
        <el-table-column property="userName" label="用户昵称"></el-table-column>
        <el-table-column property="countMoney" label="分类">
          <template slot-scope="scope">
            <el-button size="mini" v-if="scope.row.userType =='0'" type="text">普通用户</el-button>
            <el-button size="mini" v-if="scope.row.userType =='1'" type="text">会员用户</el-button>
          </template>
        </el-table-column>
        <el-table-column property="phone" label="手机号码"></el-table-column>
        <el-table-column :formatter="formatDate" property="registerTime" label="注册时间"></el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import headTop from "../components/headTop";
import { getinstitution } from "../api/api";
export default {
  data() {
    return {
      filters: {
        name: ""
      },
      value:'',
      options: [
        {
          value: " ",
          label: "全部"
        },
        {
          value: "0",
          label: "普通用户"
        },
        {
          value: "1",
          label: "会员用户"
        }
      ],
      tableData: [],
      limit: 20,
      total: 0,
      currentPage: 1
    };
  },
  components: {
    headTop
  },
  activated() {
    this.getinstitution();
  },
  methods: {
    //时间戳转换
    formatDate: function(value) {
      var dateee = new Date(value.registerTime * 1000).toJSON();
      return new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
    },
    getinstitution() {
      //机构用户列表
      let params = {
        pageNum: this.currentPage,
        pageSize: this.limit,
        organizationUserId: this.$route.query.id,
        userName:this.filters.name,
        userType:this.value
      };
      //机构用户列表
      getinstitution(params)
        .then(res => {
          this.tableData = res.data.pageInfo;
          this.total = res.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getinstitution();
    }
  },
};
</script>

<style lang="less">
@import "../style/mixin";
</style>




// WEBPACK FOOTER //
// src/page/institution.vue